// extracted by mini-css-extract-plugin
export default {"root":"Videos_root__NXm7U"};